import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,  // Default retry behavior
      refetchOnWindowFocus: false  // Disable refetch on window focus
    }
  }
});

export default queryClient;
